/**
 * Retorna a URL base da API, priorizando a variável de ambiente REACT_APP_API_BASE_URL.
 * Caso não definida, monta a URL a partir do hostname atual.
 *
 * @returns {string} URL base sem barra no final
 */
export function getBaseURL() {
    if (process.env.REACT_APP_API_BASE_URL) {
        return process.env.REACT_APP_API_BASE_URL;
    }

    const { protocol, hostname, port } = window.location;
    const showPort = port && port !== '80' && port !== '443';

    return `${protocol}//${hostname}${showPort ? ':' + process.env.REACT_APP_API_BASE_PORT : ''}`;
}

/*function getBaseURL() {
    if (!process.env.REACT_APP_API_BASE_URL)
        return `${window.location.protocol}//${window.location.hostname}${window.location.port != '80' ? ':' + process.env.REACT_APP_API_BASE_PORT : ''}`

    return process.env.REACT_APP_API_BASE_URL
}*/
